import React, { useEffect } from 'react';

import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { postOfficeGasv3ListenerStore } from '../store';

export const useGasv3Listener = (eventToMatch: AnalyticsEventPayload): boolean => {
	const { subscribe } = postOfficeGasv3ListenerStore;
	const [showMessage, setShowMessage] = React.useState(false);
	useEffect(() => {
		if (!eventToMatch || Object.keys(eventToMatch).length === 0) {
			if (process.env.NODE_ENV !== 'production') {
				// eslint-disable-next-line no-console
				console.error(
					'[Post Office] useGasv3Listener called with an empty eventToMatch. This is not allowed. Please provide a valid eventToMatch.',
				);
			}
			return () => {};
		}

		return subscribe(eventToMatch, () => setShowMessage(true));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [eventToMatch]);

	return showMessage;
};
